import { render, staticRenderFns } from "./ConsumerIcon.vue?vue&type=template&id=2cc828ee"
import script from "./ConsumerIcon.vue?vue&type=script&lang=js"
export * from "./ConsumerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports